export const CAPTCHA_CONSENT_COOKIE = "diality_recaptcha_consent";
export const CAPTCHA_CONSENT_EVENT = "diality:recaptcha-consent-change";
export const CAPTCHA_SCRIPT_ID = "diality-recaptcha-script";
let channel: BroadcastChannel | undefined;
/** Keep already-loaded Google code from running in another tab after withdrawal. */
export function syncCaptchaConsentAcrossTabs(): void {
  if (channel || !("BroadcastChannel" in window)) return;
  channel = new BroadcastChannel("diality-recaptcha-consent");
  channel.onmessage = () => {
    window.dispatchEvent(new Event(CAPTCHA_CONSENT_EVENT));
    if (!hasCaptchaConsent() && document.getElementById(CAPTCHA_SCRIPT_ID)) {
      window.location.reload();
    }
  };
}
export function readCaptchaConsent(cookie: string): boolean {
  return cookie
    .split(";")
    .some((part) => part.trim() === `${CAPTCHA_CONSENT_COOKIE}=granted`);
}
export function hasCaptchaConsent(): boolean {
  return readCaptchaConsent(document.cookie);
}
/** Consent records are first-party preferences; granting does not load Google. */
export function setCaptchaConsent(granted: boolean): void {
  document.cookie = `${CAPTCHA_CONSENT_COOKIE}=${granted ? "granted" : "denied"}; Path=/; Max-Age=31536000; SameSite=Lax${window.location.protocol === "https:" ? "; Secure" : ""}`;
  window.dispatchEvent(new Event(CAPTCHA_CONSENT_EVENT));
  syncCaptchaConsentAcrossTabs();
  channel?.postMessage("choice-changed");
  // Removing a script element does not unload its code. A new document does.
  if (!granted && document.getElementById(CAPTCHA_SCRIPT_ID))
    window.location.reload();
}
